(function () {
  var hlsLibraryPromise = null;

  function loadHlsLibrary() {
    if (!hlsLibraryPromise) {
      hlsLibraryPromise = new Promise(function (resolve, reject) {
        if (window.Hls) {
          resolve(window.Hls);
          return;
        }

        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
        script.onload = function () {
          resolve(window.Hls);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    return hlsLibraryPromise;
  }

  // Fast start: lowest quality first
  var PREVIEW_HLS_CONFIG = { startLevel: 0, capLevelToPlayerSize: true, maxBufferLength: 10 };

  function attachSource(video, src, hlsConfig) {
    return new Promise(function (resolve) {
      if (video.canPlayType('application/vnd.apple.mpegurl') || !/\.m3u8/.test(src)) {
        video.src = src;
        resolve();
        return;
      }

      loadHlsLibrary()
        .then(function (Hls) {
          if (!Hls || !Hls.isSupported()) return;
          var hls = new Hls(hlsConfig);
          hls.loadSource(src);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, resolve);
        })
        .catch(function () {});
    });
  }

  function initPlayer(container) {
    // Init once (script is rendered per section)
    if (container.hasAttribute('data-hls-init')) return;
    container.setAttribute('data-hls-init', '');

    var video = container.querySelector('.hls-video__video:not(.hls-video__video--preview)');
    var previewVideo = container.querySelector('.hls-video__video--preview');
    var src = container.getAttribute('data-video-src');
    var mobileVideoSrc = container.getAttribute('data-video-src-mobile');
    if (mobileVideoSrc && window.matchMedia('(max-width: 550px)').matches) src = mobileVideoSrc;
    var preview = container.hasAttribute('data-preview');
    var activated = false;
    var sourcePromise = null;

    if (!video || !src) return;

    if (preview) video.muted = true;

    function play(el) {
      return el.play().catch(function () {});
    }

    function loadSource() {
      if (!sourcePromise) sourcePromise = attachSource(video, src, preview && !previewVideo ? PREVIEW_HLS_CONFIG : undefined);
      return sourcePromise;
    }

    function updateVisual() {
      container.classList.toggle('hls-video--playing', activated && !video.paused);
    }

    function activate() {
      var first = !activated;
      activated = true;
      container.classList.add('hls-video--activated');

      loadSource().then(function () {
        if (preview && first) video.currentTime = 0;
        video.muted = false;
        play(video);
      });
    }

    container.addEventListener('click', function () {
      // Preview mode: resume with sound
      if (!activated || (preview && video.paused)) {
        activate();
      } else if (video.paused) {
        play(video);
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', updateVisual);
    video.addEventListener('pause', updateVisual);

    if (!preview) return;

    if (previewVideo) {
      previewVideo.addEventListener('playing', function () {
        container.classList.add('hls-video--preview-ready');
      });
    }

    // Unlock blocks below the video at the configured time
    var revealAfter = parseFloat(container.getAttribute('data-reveal-after'));
    if (revealAfter > 0 && !document.documentElement.classList.contains('hls-video-unlocked')) {
      video.addEventListener('timeupdate', function unlock() {
        if (!activated || video.currentTime < revealAfter) return;
        video.removeEventListener('timeupdate', unlock);
        document.documentElement.classList.add('hls-video-unlocked');
        try {
          sessionStorage.setItem('hls-video-unlocked:' + location.pathname, '1');
        } catch (e) {}
        // Recalculate sliders in the revealed blocks
        window.requestAnimationFrame(function () {
          document.querySelectorAll('.swiper-initialized').forEach(function (el) {
            if (el.swiper) el.swiper.update();
          });
          window.dispatchEvent(new Event('resize'));
        });
      });
    }

    // Back to preview on pause
    video.addEventListener('pause', function () {
      if (!activated) return;
      container.classList.remove('hls-video--main-playing');
      if (previewVideo) play(previewVideo);
    });

    // Hide preview while main video plays
    video.addEventListener('playing', function () {
      if (!activated) return;
      container.classList.add('hls-video--main-playing');
      if (previewVideo) previewVideo.pause();
    });

    function startPreview() {
      if (previewVideo) {
        var previewSrc = previewVideo.getAttribute('data-preview-src');
        var mobileSrc = previewVideo.getAttribute('data-preview-src-mobile');
        if (mobileSrc && window.matchMedia('(max-width: 550px)').matches) previewSrc = mobileSrc;
        attachSource(previewVideo, previewSrc, PREVIEW_HLS_CONFIG).then(function () {
          if (!activated) play(previewVideo);
        });
      } else {
        loadSource().then(function () {
          if (!activated) play(video);
        });
      }
    }

    if (container.getBoundingClientRect().top < window.innerHeight * 2) {
      startPreview();
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          startPreview();
        },
        { rootMargin: '200px' }
      );
      observer.observe(container);
    } else {
      startPreview();
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hls-video').forEach(initPlayer);
  }

  initAll();

  // Re-init after theme editor re-render
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
